import React from 'react'
import { withRouter } from "react-router-dom";
import { FormComponent } from '../../../../components/form/DynamicForm';
import { Form, Validators } from '../../../../components/form/DynamicFormTs';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import Http from '../../../../Http';
import AsingnarLP from './AsingnarLP'
import ACCESS from '../../../../ACCESS';
class ClienteVentas extends FormComponent {

  componentDidMount() {
    const { hasAccess } = this.context
    this.esContado = !hasAccess(ACCESS.CATALOGO_CLIENTES.CREAR_SOLO_CONTADO)
    this.FormConfig(
      { defaultUrl: 'cliente/administrativo', saveUrl: 'cliente/save', backUrl: '/Catalogo/Cliente/' + this.props.match.params.id + '/Administrativos' },
      new Form([
        Form.Field('select', 'cliente_id_condicion_pago', 'Condiciones de pago', 1, [Validators.required], 6, [], [], [], false, this.esContado),
        Form.Field('number', 'cliente_limite_credito', 'Límite de crédito', '', [], 6),        
        Form.Field('select', 'cliente_dias_revision', 'Días de revisión', 1, [Validators.required], 3, []),
        Form.Field('select', 'cliente_dias_pago', 'Días de pago', 1, [Validators.required], 3, []),
        Form.Field('select', 'cliente_id_oficina_cobra', 'Oficina que cobra', '', [Validators.required], 6, []),
        Form.Field('select', 'cliente_dia_facturacion', 'Día de facturación', 1, [Validators.required], 3, []),
        Form.Field('select', 'cliente_modo_facturacion', 'Modo de facturación', 1, [Validators.required], 3, []),
        Form.Field('select', 'cliente_id_gestor', 'Gestor de cobranza', '', [], 6, []),
        Form.Field('checkbox', 'cliente_mail_copia', 'Enviar copia guía por mail', '', [], 3, []),
        Form.Field('checkbox', 'cliente_factura_sin_entrega', 'Saltar proceso de guia para factura', '', [], 3, []),
        Form.Field('textarea', 'cliente_obs_facuracion', 'Observaciones de facturación', '', [], 6, []),
        Form.Field('checkbox', 'cliente_digitalizar', 'Digitalizar', 1, [], 4, []),
        Form.Field('select', 'cliente_estado', 'Estado de cliente', 1, [Validators.required], 4, []),
        Form.Field('date', 'cliente_fecha_suspension', 'Fecha de suspensión', '', [], 4, [], [], [], false, true),
        // campo para que el rfc sea obligatorio
        Form.Field('checkbox', 'cliente_rfc_destrem', 'RFC EN DESTINATARIOS Y REMITENTES', false, [], 12, []),
        // campo para incluir la clave de la colonia en el remitente y destinatario
        Form.Field('checkbox', 'cliente_clave_colonia_sat', 'CLAVE SAT EN REMITENTE Y DESTINATARIOS', false, [], 12, []),
        Form.Section('Embarques', 2),
        Form.Field('select', 'cliente_id_tipo_carta_porte', 'Tipo Carta Porte', 1, [Validators.required], 6, [
          { Label: 'Por guia', Value: '1'},
          { Label: 'Agrupado', Value: '2'},
          { Label: 'No Generar', Value: '3'},
        ]),
        Form.Section('Papelería obligatoria', 2),
        Form.Field('checkbox', 'cliente_pape_factura', 'Factura', '', [], 3, []),
        Form.Field('checkbox', 'cliente_pape_remision', 'Remisión', '', [], 3, []),
        Form.Field('checkbox', 'cliente_pape_salida', 'Orden salida', '', [], 3, []),
        Form.Field('checkbox', 'cliente_pape_tarima', 'Vale tarima', '', [], 3, []),
        Form.Section('Documentacion', 2),
        Form.Field('checkbox', 'cliente_asignacion_directa', 'Asignación de guias a transportista directa', '', [], 4, []),
        Form.Field('checkbox', 'cliente_redocumentar', 'Permitir Redocumentar Guias', '', [], 4, []),
        Form.Field('checkbox', 'cliente_cancelar', 'Permitir Cancelar Guias', '', [], 4, []),
        Form.Section('Entregas y Remisiones (3M / Manifiestos)', 2),
        Form.Field('checkbox', 'cliente_requiere_remisiones_entrega', 'Requiere registro de remisiones en entrega', false, [], 6, []),
        Form.Field('text', 'cliente_whatsapp_coordinador', 'Teléfono / WhatsApp Coordinador para Alertas', '', [], 6, []),
        Form.Section('Reportes', 2),
        Form.Field('checkbox', 'cliente_omitir_seguro', 'No mostrar Seguro en Reportes', '', [], 4, []),
      ], ['Guardar']), this.formData
    )
    if (this.props.match.params.id) {
      this.LoadPreds(this.props.match.params.id);
    }
  }

  LoadPreds = async (predId = null, callOnChange = true) => {
    let id = predId ? predId : this.props.match.params.id;
    let Res = await Http.get(`cliente/administrativo/${id}`);
    if (!Res.error) {
      this.setState({ 
        FormData: Form.Patch(this.state.FormData, Res.data, callOnChange), 
        cliente_id_condicion_pago: Res.data.cliente_id_condicion_pago,
        id_cliente: Res.data.id
      })
    }
    return Res.data;
  }

  formData = async (form, ejecutivo = null) => {
    const Res = await Http.get(`cliente/form/administrativos${(ejecutivo) ? `?e=${ejecutivo}` : ''}`);
    let newForm = form;
    if (!Res.error) {
      newForm = Form.FieldOptions(newForm, 'cliente_id_condicion_pago', Res.data.condiciones_pago, 'id', 'condicion_nombre');
      newForm = Form.FieldOptions(newForm, 'cliente_dias_revision', Res.data.dias, 'id', 'dia');
      newForm = Form.FieldOptions(newForm, 'cliente_dias_pago', Res.data.dias, 'id', 'dia');
      newForm = Form.FieldOptions(newForm, 'cliente_dia_facturacion', Res.data.dias, 'id', 'dia');
      newForm = Form.FieldOptions(newForm, 'cliente_id_oficina_cobra', Res.data.sucursales, 'id', 'sucursal_nombre');
      newForm = Form.FieldOptions(newForm, 'cliente_modo_facturacion', Res.data.facturacion_modos, 'id', 'facturacion_modo');
      newForm = Form.FieldOptions(newForm, 'cliente_estado', Res.data.cliente_estados, 'id', 'cliente_estado');
      newForm = Form.FieldOptions(newForm, 'cliente_id_gestor', Res.data.gestores, 'id', 'gestor_nombre');
      // if (Res.data.ejecutivos) newForm = Form.FieldOptions(newForm, 'cliente_ejecutivo_nombre', Res.data.ejecutivos, 'id', 'ejecutivo_nombre');
      // newForm = Form.ValueChange(newForm, { cliente_ejecutivo_nombre: this.ejecutivoChange });
      newForm = Form.ValueChange(newForm, { cliente_estado: this.estadoChange });
    }
    newForm = Form.ValueChange(newForm, {
      cliente_id_condicion_pago: this.condicionPagoChange,
    });
    return newForm;
  }

  estadoChange = async (field) => {
    this.setState({
      FormData: Form.FieldMod(this.state.FormData, 'cliente_fecha_suspension', 'Disabled', field.Value === "1")
    })
  }

  ejecutivoChange = async (field) => {
    // this.setState({ FormData: await this.formData(this.state.FormData, field.Value) })
    if (field.Value) {
      console.log(field)
      let Res = await Http.get(`ejecutivo/one/${field.Value}`);
      console.log(Res.data)
      if (!Res.error) {
        Res.data.cliente_id_ejecutivo = Res.data.id
        this.setState({ FormData: Form.Patch(this.state.FormData, Res.data, true) })
      }
    }
    else {
      this.setState({ FormData: await this.formData(this.state.FormData, field.ValueAt) })
    }
  }

  condicionPagoChange = async (field) => {
    const { cliente_id_condicion_pago } = this.state;
    if ((`${cliente_id_condicion_pago}` === "8" && `${field.Value}` !== "8") 
      || (`${cliente_id_condicion_pago}` !== "8" && `${field.Value}` === "8")) {
      this.setState({ chooseLP: true, cliente_id_condicion_pago: field.Value });
    }
  }

  chooseLPClose = (field) => {
    this.setState({ chooseLP: false });
  }

  // onSubmit = async (i, vals) => {
  //   console.log(vals)
    // vals.id = this.props.match.params.id;
    // var Res = await Http.post(`${this.config.saveUrl}`, vals);
    // if (!Res.error) {
    //   this.setState({ loading: false, sbMsg: 'Guardado', sbOpen: true });
    //   this.props.onSave();
    // }
    // else
    //   this.setState({ loading: false, sbMsg: 'Error al guardar', sbOpen: true });

  // }

  render() {
    const { chooseLP = false, id_cliente, cliente_id_condicion_pago } = this.state; 
    return (
      <div>
        <this.FormRender />
        <Dialog  open={chooseLP} fullWidth={true} maxWidth={'md'}>
          <DialogTitle onClose={this.chooseLPClose}>
            Asignar Listas de Precio
          </DialogTitle>
          <DialogContent dividers>
            {"Se asignaran las Listas de Precios correspondientes a la condicion de pago y se quitaran las Listas de la condicion de pago previa"}
            <AsingnarLP id_cliente={id_cliente} cliente_id_condicion_pago={cliente_id_condicion_pago} onSave={() => { this.setState({ chooseLP: false }) }} />
          </DialogContent>
        </Dialog>
      </div>
    )
  }
}

export default withRouter(ClienteVentas)
